import { fetchDeleteCreditCardTellMoneyUserConsent } from '@iwoca/lapi-client/edge';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getTellMoneyUserConsentKey } from './queryKeys';
import { useStateKey } from '../../../../iwQueryClient/useStateKey';

export const useDeleteTellMoneyConsent = () => {
    const stateKey = useStateKey();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (consentId: string) => {
            await fetchDeleteCreditCardTellMoneyUserConsent({
                consentId,
                stateKey
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: getTellMoneyUserConsentKey(stateKey)
            });
        }
    });
};
